


















































import { Component, Prop, Vue } from "vue-property-decorator";
import * as def from "@/definitions";

import { DateTextLayer } from "@/model/document2/page/surface/design/layer/dateTextLayer";
import { ColorConstruct } from "@/utilityModels/colorConstruct";

import TextColorController from "./textColorController/textColorController.vue";
import FontSizeController from "./fontSizeController/fontSizeController.vue";
import FontStyleController from "./fontStyleController/fontStyleController.vue";
import TextOutlineController from "./textOutlineController/textOutlineController.vue";
import TextOutlineColorController from "./textOutlineColorController/textOutlineColorController.vue";
import TextShadowColorController from "./textShadowColorController/textShadowColorController.vue";
import TextSpacingController from "./textSpacingController/textSpacingController.vue";
import TextShadowController from "./textShadowController/textShadowController.vue";

@Component({
    components: {
        TextColorController,
        FontSizeController,
        FontStyleController,
        TextOutlineController,
        TextOutlineColorController,
        TextShadowColorController,
        TextSpacingController,
        TextShadowController
    }
})

//******************************************//
//**************** モバイル用 ****************//
//******************************************//
export default class DateTextController extends Vue 
{
    @Prop() layer! : DateTextLayer;

    private textControllerType = "textColor";

    private isActive(type)
    {
        return this.textControllerType == type;
    }

    private changeType(type : string)
    {
        this.textControllerType = type;
    }

    private onChangeTextInfo(propertyName : string, value : any, isFinish : boolean, isOnce : boolean)
    {
        var newTextInfo = this.layer.textInfo.clone();
        newTextInfo[propertyName] = value;
        this.onChangeLayerProperty("textInfo", newTextInfo, isFinish, isOnce);
    }

    private onChangeLayerProperty(propertyName : string, value : any, isFinish : boolean, isOnce : boolean)
    {   
        this.$emit("doCommand", "changeLayerProperty", {  
            layer : this.layer,
            propertyName : propertyName,
            value : value,
            isFinish : isFinish,
            isOnce : isOnce
        });
    }

    private onRequestColor(propertyName : string, currentValue : ColorConstruct)
    {
        var parameter = {};
        parameter["propertyName"] = propertyName;
        parameter["type"] = "color";
        var hex = currentValue.hex;
        if(hex.substr(0, 1) == "#") { hex = hex.substr(1, 6); }
        parameter["currentValue"] = hex;
        this.$emit("doCommand", "sendNativeEvent", {
            message : "request_layer_property",
            parameter : parameter
        });
    }

    private changeText()
    {
        var parameter = {};
        parameter["propertyName"] = "text";
        parameter["type"] = "string";
        parameter["currentValue"] = "";
        this.$emit("doCommand", "sendNativeEvent", {
            message : "request_layer_property",
            parameter : parameter
        });
    }

    private changeFont()
    {
        var parameter = {};
        parameter["propertyName"] = "fontId";
        parameter["type"] = "string";
        parameter["currentValue"] = this.layer.textInfo.fontId;
        this.$emit("doCommand", "sendNativeEvent", {
            message : "request_layer_property",
            parameter : parameter
        });
    }
}
